import { legacyMegaraxHttpService } from "@legacy-megarax/crm-contracts";
import React, { useContext } from "react";

import { accountPreferencesHttpService } from "@megaron/account-preferences-contracts";
import { authHttpService } from "@megaron/auth-contracts";
import { cashRewardsHttpService } from "@megaron/cash-rewards-contracts";
import { catalogHttpService } from "@megaron/catalog-contracts";
import { commentsHttpService } from "@megaron/comments-contracts";
import { crmHttpService } from "@megaron/crm-contracts";
import { cubeHttpService } from "@megaron/cube-proxy-contracts";
import { docsHttpService } from "@megaron/docs-contracts";
import { fulfillmentHttpService } from "@megaron/fulfillment-contracts";
import { HttpServiceClient } from "@megaron/http-service-client";
import { invoicesHttpService } from "@megaron/invoices-contracts";
import { pointsHttpService } from "@megaron/loyalty-points-contracts";
import { qrSyncService } from "@megaron/loyalty-qr-sync-contracts";
import { notificationsHttpService } from "@megaron/notifications-contracts";
import { shippingHttpService } from "@megaron/shipping-contracts";
import { supportHttpService } from "@megaron/support-contracts";
import { Failure, Ok } from "@megaron/result";

export type ClientAction<TIn, TValue, TErr> = (input: TIn) => Promise<Ok<TValue> | Failure<TErr>>;

export type Clients = {
  auth: HttpServiceClient<typeof authHttpService>;
  notifications: HttpServiceClient<typeof notificationsHttpService>;
  accountPreferences: HttpServiceClient<typeof accountPreferencesHttpService>;
  loyaltyPoints: HttpServiceClient<typeof pointsHttpService>;
  catalog: HttpServiceClient<typeof catalogHttpService>;
  crm: HttpServiceClient<typeof crmHttpService>;
  cube: HttpServiceClient<typeof cubeHttpService>;
  docs: HttpServiceClient<typeof docsHttpService>;
  qrSync: HttpServiceClient<typeof qrSyncService>;
  invoices: HttpServiceClient<typeof invoicesHttpService>;
  support: HttpServiceClient<typeof supportHttpService>;
  legacyMegarax: HttpServiceClient<typeof legacyMegaraxHttpService>;
  fulfillment: HttpServiceClient<typeof fulfillmentHttpService>;
  cashRewards: HttpServiceClient<typeof cashRewardsHttpService>;
  comments: HttpServiceClient<typeof commentsHttpService>;
  shipping: HttpServiceClient<typeof shippingHttpService>;
};

export const ClientContext = React.createContext<Partial<Clients>>({});

export type ClientName = keyof Clients;

export const useServiceClient = <TName extends keyof Clients>(serviceName: TName): Clients[TName] => {
  const clients = useContext(ClientContext);
  const client = clients[serviceName];

  if (client === undefined) {
    throw new Error(`No client for service ${serviceName} found`);
  }
  return client!;
};
